// extracted by mini-css-extract-plugin
module.exports = {"s9tg3ao":"s9tg3ao","ptz92tw":"ptz92tw"};